import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { levelChangesSearchSchema } from "./-lib/search-schema";



export const Route = createFileRoute("/_protected/staff/level-changes/")({
  head: () => ({
    meta: [{ title: "调级历史 · imiker CRM" }],
  }),
  validateSearch: levelChangesSearchSchema,
  search: {
    middlewares: [stripSearchParams({ coach: "all" as const })],
  }
});
